export const modelConfigValueMapping = {
  fraud: "Fraud",
  aml: "AML",
  amount: "Amount",
  class_balancing: "Class Balancing",
  combined: "Combined",
  day: "Day",
  week: "Week",
  month: "Month",
  year: "Year",
  positive: "Positive",
  negative: "Negative",
  kfold: "Random Kfold",
  timeseries_by_n_transactions: "Timeseries by number of transactions",
  false: "No",
  true: "Yes",
  "11": "10",
  "101": "100",
  "1001": "1000",
};

export const convertModelconfigValueToFrontendValue = new Map(
  Object.entries(modelConfigValueMapping)
);

export const modelConfigKeyMapping = {
  modelversion_name: "Model Name",
  nthresholds: "Threshold granularity",
  alert_only_dataset: "Alert only dataset",
  alert_only_training: "Alert only training",
  alert_only_reporting: "Alert only reporting",
  loss: "Optimization function",
  fp_cost: "False Positive costs",
  ambiguous_label: "Assign ambiguous label",
  column: "Entity column",
  amount: "Amount column",
  timeframe: "Timeframe",
  datetime: "Datetime column",
  cv_type: "Cross validation type",
  cv_n_splits: "Number of folds",
  cv_time_unit: "Time unit",
  cv_train_timespan: "Training period",
  cv_test_timespan: "Testing period",
  cv_with_future: "Include future data for training",
};

export const convertModelconfigKeyToName = new Map(
  Object.entries(modelConfigKeyMapping).map(([key, displayName]) => [key, displayName])
);
